export default __webpack_public_path__ + "media/images/home/slide_2week_private_room_lg-ad3e5f7bd3eb5da4b121ef5fc548d622.jpg";